import axios from '@/lib/axios';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { hasTokenCookie } from '@/lib/cookies';

interface IsLoggedInResponse {
  error: boolean;
  data?: {
    user?: string;
  };
}

const getIsLoggedInQuery = async (): Promise<IsLoggedInResponse> => {
  const response = await axios.get('/auth/is-loggedin');
  return response.data;
};

export const useGetUserIsLoggedInQuery = (
  options?: Partial<UseQueryOptions<IsLoggedInResponse>>
) => {
  // Check if token exists in cookie before making the API call
  const hasToken = hasTokenCookie();

  return useQuery({
    queryKey: ['user', 'is-logged-in'],
    queryFn: getIsLoggedInQuery,
    retry: false,
    enabled: hasToken,
    ...options,
  });
};
